export default __webpack_public_path__ + "static/media/richard.3ea4c088.jpeg";